// extracted by extract-css-chunks-webpack-plugin
module.exports = {"prev":"ZjZ9t","next":"W2vCx","playButton":"_5afuw","playButtonVideoPlacement":"PReMu","text":"mw-kv","carouselContainerGallery":"iVeUg","slideContainer":"vigZS"};